import styled from 'styled-components';
import BaseImage from 'components/image/baseImage.jsx';
export const Image = styled(BaseImage).withConfig({
  displayName: "selfiecss__Image",
  componentId: "sc-1iz9f0g-0"
})(["border-radius:50%;border:2px solid powderblue !important;margin-bottom:1rem;"]);